const jobCategoryIdToSubcategoryMapping = {
  L1000_L2000_L3000: ["L1000_L2001_L3000"],
  L1001_L2000_L3000: [
    "L1001_L2001_L3000",
    "L1001_L2002_L3000",
    "L1001_L2003_L3000",
    "L1001_L2004_L3000",
    "L1001_L2005_L3000"
  ],
  L1002_L2000_L3000: [
    "L1002_L2001_L3000",
    "L1002_L2002_L3000",
    "L1002_L2003_L3000",
    "L1002_L2004_L3000"
  ],
  L1003_L2000_L3000: ["L1003_L2001_L3000"],
  L1004_L2000_L3000: ["L1004_L2001_L3000", "L1004_L2002_L3000"],
  L1005_L2000_L3000: ["L1005_L2001_L3000"],
  L1006_L2000_L3000: ["L1006_L2001_L3000", "L1006_L2002_L3000"],
  L1007_L2000_L3000: ["L1007_L2001_L3000", "L1007_L2002_L3000"],
  L1008_L2000_L3000: [
    "L1008_L2001_L3000",
    "L1008_L2002_L3000",
    "L1008_L2003_L3000",
    "L1008_L2004_L3000",
    "L1008_L2005_L3000",
    "L1008_L2006_L3000"
  ],
  L1009_L2000_L3000: ["L1009_L2001_L3000", "L1009_L2002_L3000"],
  L1010_L2000_L3000: ["L1010_L2001_L3000", "L1010_L2002_L3000"],
  L1011_L2000_L3000: ["L1011_L2001_L3000", "L1011_L2002_L3000", "L1011_L2003_L3000"],
  L1012_L2000_L3000: ["L1012_L2001_L3000"],
  L1013_L2000_L3000: ["L1013_L2001_L3000", "L1013_L2002_L3000"],
  L1014_L2000_L3000: ["L1014_L2001_L3000", "L1014_L2002_L3000"],
  L1015_L2000_L3000: ["L1015_L2001_L3000", "L1015_L2002_L3000"],
  L1016_L2000_L3000: ["L1016_L2001_L3000", "L1016_L2002_L3000", "L1016_L2003_L3000"],
  L1002_L2001_L3000: ["L1002_L2001_L3001", "L1002_L2001_L3002"],
  L1002_L2002_L3000: ["L1002_L2002_L3001", "L1002_L2002_L3002"],
  L1002_L2003_L3000: ["L1002_L2003_L3001", "L1002_L2003_L3002", "L1002_L2003_L3003"],
  L1002_L2004_L3000: ["L1002_L2004_L3001", "L1002_L2004_L3002", "L1002_L2004_L3003"],
  L1003_L2001_L3000: ["L1003_L2001_L3001", "L1003_L2001_L3002", "L1003_L2001_L3003"],
  L1004_L2001_L3000: [
    "L1004_L2001_L3001",
    "L1004_L2001_L3002",
    "L1004_L2001_L3003",
    "L1004_L2001_L3004",
    "L1004_L2001_L3005",
    "L1004_L2001_L3006",
    "L1004_L2001_L3007",
    "L1004_L2001_L3008"
  ],
  L1004_L2002_L3000: [
    "L1004_L2002_L3001",
    "L1004_L2002_L3002",
    "L1004_L2002_L3003",
    "L1004_L2002_L3004",
    "L1004_L2002_L3005"
  ],
  L1005_L2001_L3000: [
    "L1005_L2001_L3001",
    "L1005_L2001_L3002",
    "L1005_L2001_L3003",
    "L1005_L2001_L3004"
  ],
  L1006_L2001_L3000: [
    "L1006_L2001_L3001",
    "L1006_L2001_L3002",
    "L1006_L2001_L3003",
    "L1006_L2001_L3004",
    "L1006_L2001_L3005",
    "L1006_L2001_L3006",
    "L1006_L2001_L3007"
  ],
  L1006_L2002_L3000: ["L1006_L2002_L3001", "L1006_L2002_L3002"],
  L1007_L2001_L3000: [
    "L1007_L2001_L3001",
    "L1007_L2001_L3002",
    "L1007_L2001_L3003",
    "L1007_L2001_L3004",
    "L1007_L2001_L3005",
    "L1007_L2001_L3006"
  ],
  L1007_L2002_L3000: [
    "L1007_L2002_L3001",
    "L1007_L2002_L3002",
    "L1007_L2002_L3003",
    "L1007_L2002_L3004",
    "L1007_L2002_L3005"
  ],
  L1008_L2001_L3000: [
    "L1008_L2001_L3001",
    "L1008_L2001_L3002",
    "L1008_L2001_L3003",
    "L1008_L2001_L3004"
  ],
  L1008_L2002_L3000: ["L1008_L2002_L3001", "L1008_L2002_L3002", "L1008_L2002_L3003"],
  L1008_L2003_L3000: [
    "L1008_L2003_L3001",
    "L1008_L2003_L3002",
    "L1008_L2003_L3003",
    "L1008_L2003_L3004"
  ],
  L1008_L2004_L3000: [
    "L1008_L2004_L3001",
    "L1008_L2004_L3002",
    "L1008_L2004_L3003",
    "L1008_L2004_L3004",
    "L1008_L2004_L3005"
  ],
  L1008_L2005_L3000: ["L1008_L2005_L3001", "L1008_L2005_L3002", "L1008_L2005_L3003"],
  L1008_L2006_L3000: ["L1008_L2006_L3001", "L1008_L2006_L3002", "L1008_L2006_L3003"],
  L1009_L2001_L3000: ["L1009_L2001_L3001", "L1009_L2001_L3002", "L1009_L2001_L3003"],
  L1009_L2002_L3000: ["L1009_L2002_L3001"],
  L1010_L2001_L3000: ["L1010_L2001_L3001", "L1010_L2001_L3002", "L1010_L2001_L3003"],
  L1010_L2002_L3000: [
    "L1010_L2002_L3001",
    "L1010_L2002_L3002",
    "L1010_L2002_L3003",
    "L1010_L2002_L3004",
    "L1010_L2002_L3005"
  ],
  L1011_L2001_L3000: ["L1011_L2001_L3001", "L1011_L2001_L3002"],
  L1011_L2002_L3000: ["L1011_L2002_L3001", "L1011_L2002_L3002", "L1011_L2002_L3003"],
  L1011_L2003_L3000: ["L1011_L2003_L3001", "L1011_L2003_L3002", "L1011_L2003_L3003"],
  L1013_L2001_L3000: [
    "L1013_L2001_L3001",
    "L1013_L2001_L3002",
    "L1013_L2001_L3003",
    "L1013_L2001_L3004"
  ],
  L1013_L2002_L3000: [
    "L1013_L2002_L3001",
    "L1013_L2002_L3002",
    "L1013_L2002_L3003",
    "L1013_L2002_L3004",
    "L1013_L2002_L3005",
    "L1013_L2002_L3006"
  ],
  L1014_L2001_L3000: [
    "L1014_L2001_L3001",
    "L1014_L2001_L3002",
    "L1014_L2001_L3003",
    "L1014_L2001_L3004",
    "L1014_L2001_L3005"
  ],
  L1014_L2002_L3000: ["L1014_L2002_L3001", "L1014_L2002_L3002", "L1014_L2002_L3003"],
  L1015_L2001_L3000: ["L1015_L2001_L3001", "L1015_L2001_L3002", "L1015_L2001_L3003"],
  L1015_L2002_L3000: [
    "L1015_L2002_L3001",
    "L1015_L2002_L3002",
    "L1015_L2002_L3003",
    "L1015_L2002_L3004",
    "L1015_L2002_L3005"
  ],
  L1016_L2001_L3000: [
    "L1016_L2001_L3001",
    "L1016_L2001_L3002",
    "L1016_L2001_L3003",
    "L1016_L2001_L3004"
  ],
  L1016_L2002_L3000: ["L1016_L2002_L3001", "L1016_L2002_L3002", "L1016_L2002_L3003"],
  L1016_L2003_L3000: [
    "L1016_L2003_L3001",
    "L1016_L2003_L3002",
    "L1016_L2003_L3003",
    "L1016_L2003_L3004"
  ],
  L1000_L2001_L3000: [
    "L1000_L2001_L3001",
    "L1000_L2001_L3002",
    "L1000_L2001_L3003",
    "L1000_L2001_L3004",
    "L1000_L2001_L3005",
    "L1000_L2001_L3006",
    "L1000_L2001_L3007"
  ],

  L1012_L2001_L3000: [
    "L1012_L2001_L3001",
    "L1012_L2001_L3002",
    "L1012_L2001_L3004",
    "L1012_L2001_L3003"
  ],

  // LEVEL 3 => LEVEL 4
  L1006_L2001_L3001: [
    "L1006_L2001_L3001_L4001",
    "L1006_L2001_L3001_L4002",
    "L1006_L2001_L3001_L4003",
    "L1006_L2001_L3001_L4004",
    "L1006_L2001_L3001_L4005",
    "L1006_L2001_L3001_L4006"
  ],
  L1006_L2001_L3002: [
    "L1006_L2001_L3002_L4001",
    "L1006_L2001_L3002_L4002",
    "L1006_L2001_L3002_L4003",
    "L1006_L2001_L3002_L4004",
    "L1006_L2001_L3002_L4005"
  ],
  L1006_L2001_L3003: [
    "L1006_L2001_L3003_L4001",
    "L1006_L2001_L3003_L4002",
    "L1006_L2001_L3003_L4003",
    "L1006_L2001_L3003_L4004",
    "L1006_L2001_L3003_L4005",
    "L1006_L2001_L3003_L4006"
  ],
  L1006_L2001_L3004: [
    "L1006_L2001_L3004_L4001",
    "L1006_L2001_L3004_L4002",
    "L1006_L2001_L3004_L4003",
    "L1006_L2001_L3004_L4004"
  ],
  L1006_L2001_L3005: [
    "L1006_L2001_L3005_L4001",
    "L1006_L2001_L3005_L4002",
    "L1006_L2001_L3005_L4003",
    "L1006_L2001_L3005_L4004",
    "L1006_L2001_L3005_L4005"
  ],
  L1006_L2001_L3006: ["L1006_L2001_L3006_L4001", "L1006_L2001_L3006_L4002"],
  L1006_L2001_L3007: [
    "L1006_L2001_L3007_L4001",
    "L1006_L2001_L3007_L4002",
    "L1006_L2001_L3007_L4003",
    "L1006_L2001_L3007_L4004",
    "L1006_L2001_L3007_L4005"
  ],
  L1006_L2002_L3001: [
    "L1006_L2002_L3001_L4001",
    "L1006_L2002_L3001_L4002",
    "L1006_L2002_L3001_L4003",
    "L1006_L2002_L3001_L4004",
    "L1006_L2002_L3001_L4005",
    "L1006_L2002_L3001_L4006"
  ],
  L1006_L2002_L3002: ["L1006_L2002_L3002_L4001", "L1006_L2002_L3002_L4002"],
  L1008_L2001_L3001: [
    "L1008_L2001_L3001_L4001",
    "L1008_L2001_L3001_L4002",
    "L1008_L2001_L3001_L4003"
  ],
  L1008_L2001_L3002: [
    "L1008_L2001_L3002_L4001",
    "L1008_L2001_L3002_L4002",
    "L1008_L2001_L3002_L4003",
    "L1008_L2001_L3002_L4004",
    "L1008_L2001_L3002_L4005"
  ],
  L1008_L2001_L3003: [
    "L1008_L2001_L3003_L4001",
    "L1008_L2001_L3003_L4002",
    "L1008_L2001_L3003_L4003",
    "L1008_L2001_L3003_L4004",
    "L1008_L2001_L3003_L4005",
    "L1008_L2001_L3003_L4006",
    "L1008_L2001_L3003_L4007"
  ],
  L1008_L2001_L3004: [
    "L1008_L2001_L3004_L4001",
    "L1008_L2001_L3004_L4002",
    "L1008_L2001_L3004_L4003"
  ],
  L1008_L2002_L3001: [
    "L1008_L2002_L3001_L4001",
    "L1008_L2002_L3001_L4002",
    "L1008_L2002_L3001_L4003",
    "L1008_L2002_L3001_L4004"
  ],
  L1008_L2002_L3002: [
    "L1008_L2002_L3002_L4001",
    "L1008_L2002_L3002_L4002",
    "L1008_L2002_L3002_L4003",
    "L1008_L2002_L3002_L4004"
  ],
  L1008_L2002_L3003: [
    "L1008_L2002_L3003_L4001",
    "L1008_L2002_L3003_L4002",
    "L1008_L2002_L3003_L4003",
    "L1008_L2002_L3003_L4004",
    "L1008_L2002_L3003_L4005",
    "L1008_L2002_L3003_L4006",
    "L1008_L2002_L3003_L4007",
    "L1008_L2002_L3003_L4008"
  ],
  L1008_L2003_L3001: [
    "L1008_L2003_L3001_L4001",
    "L1008_L2003_L3001_L4002",
    "L1008_L2003_L3001_L4003",
    "L1008_L2003_L3001_L4004"
  ],
  L1008_L2003_L3002: [
    "L1008_L2003_L3002_L4001",
    "L1008_L2003_L3002_L4002",
    "L1008_L2003_L3002_L4003",
    "L1008_L2003_L3002_L4004"
  ],
  L1008_L2003_L3003: [
    "L1008_L2003_L3003_L4001",
    "L1008_L2003_L3003_L4002",
    "L1008_L2003_L3003_L4003"
  ],
  L1008_L2003_L3004: [
    "L1008_L2003_L3004_L4001",
    "L1008_L2003_L3004_L4002",
    "L1008_L2003_L3004_L4003"
  ],
  L1008_L2004_L3001: [
    "L1008_L2004_L3001_L4001",
    "L1008_L2004_L3001_L4002",
    "L1008_L2004_L3001_L4003",
    "L1008_L2004_L3001_L4004",
    "L1008_L2004_L3001_L4005",
    "L1008_L2004_L3001_L4006"
  ],
  L1008_L2004_L3002: [
    "L1008_L2004_L3002_L4001",
    "L1008_L2004_L3002_L4002",
    "L1008_L2004_L3002_L4003",
    "L1008_L2004_L3002_L4004",
    "L1008_L2004_L3002_L4005",
    "L1008_L2004_L3002_L4006"
  ],
  L1008_L2004_L3003: [
    "L1008_L2004_L3003_L4001",
    "L1008_L2004_L3003_L4002",
    "L1008_L2004_L3003_L4003"
  ],
  L1008_L2004_L3004: [
    "L1008_L2004_L3004_L4001",
    "L1008_L2004_L3004_L4002",
    "L1008_L2004_L3004_L4003",
    "L1008_L2004_L3004_L4004"
  ],
  L1008_L2004_L3005: [
    "L1008_L2004_L3005_L4001",
    "L1008_L2004_L3005_L4002",
    "L1008_L2004_L3005_L4003",
    "L1008_L2004_L3005_L4004"
  ],
  L1011_L2001_L3001: [
    "L1011_L2001_L3001_L4001",
    "L1011_L2001_L3001_L4002",
    "L1011_L2001_L3001_L4003",
    "L1011_L2001_L3001_L4004",
    "L1011_L2001_L3001_L4005",
    "L1011_L2001_L3001_L4006"
  ],
  L1011_L2001_L3002: [
    "L1011_L2001_L3002_L4001",
    "L1011_L2001_L3002_L4002",
    "L1011_L2001_L3002_L4003",
    "L1011_L2001_L3002_L4004",
    "L1011_L2001_L3002_L4005",
    "L1011_L2001_L3002_L4006",
    "L1011_L2001_L3002_L4007"
  ],
  L1011_L2002_L3001: [
    "L1011_L2002_L3001_L4001",
    "L1011_L2002_L3001_L4002",
    "L1011_L2002_L3001_L4003"
  ],
  L1011_L2002_L3002: [
    "L1011_L2002_L3002_L4001",
    "L1011_L2002_L3002_L4002",
    "L1011_L2002_L3002_L4003",
    "L1011_L2002_L3002_L4004",
    "L1011_L2002_L3002_L4005",
    "L1011_L2002_L3002_L4006",
    "L1011_L2002_L3002_L4007"
  ],
  L1011_L2002_L3003: [
    "L1011_L2002_L3003_L4001",
    "L1011_L2002_L3003_L4002",
    "L1011_L2002_L3003_L4003",
    "L1011_L2002_L3003_L4004",
    "L1011_L2002_L3003_L4005",
    "L1011_L2002_L3003_L4006"
  ],
  L1011_L2003_L3001: [
    "L1011_L2003_L3001_L4001",
    "L1011_L2003_L3001_L4002",
    "L1011_L2003_L3001_L4003"
  ],
  L1011_L2003_L3002: [
    "L1011_L2003_L3002_L4001",
    "L1011_L2003_L3002_L4002",
    "L1011_L2003_L3002_L4003",
    "L1011_L2003_L3002_L4004",
    "L1011_L2003_L3002_L4005"
  ],
  L1011_L2003_L3003: [
    "L1011_L2003_L3003_L4001",
    "L1011_L2003_L3003_L4002",
    "L1011_L2003_L3003_L4003"
  ],
  L1008_L2005_L3001: [
    "L1008_L2005_L3001_L4001",
    "L1008_L2005_L3001_L4002",
    "L1008_L2005_L3001_L4003",
    "L1008_L2005_L3001_L4004",
    "L1008_L2005_L3001_L4005",
    "L1008_L2005_L3001_L4006"
  ],
  L1008_L2005_L3002: [
    "L1008_L2005_L3002_L4001",
    "L1008_L2005_L3002_L4002",
    "L1008_L2005_L3002_L4003",
    "L1008_L2005_L3002_L4004",
    "L1008_L2005_L3002_L4005"
  ],
  L1008_L2005_L3003: [
    "L1008_L2005_L3003_L4001",
    "L1008_L2005_L3003_L4002",
    "L1008_L2005_L3003_L4003",
    "L1008_L2005_L3003_L4004",
    "L1008_L2005_L3003_L4005",
    "L1008_L2005_L3003_L4006"
  ],
  L1008_L2006_L3001: [
    "L1008_L2006_L3001_L4001",
    "L1008_L2006_L3001_L4002",
    "L1008_L2006_L3001_L4003",
    "L1008_L2006_L3001_L4004",
    "L1008_L2006_L3001_L4005",
    "L1008_L2006_L3001_L4006",
    "L1008_L2006_L3001_L4007"
  ],
  L1008_L2006_L3002: [
    "L1008_L2006_L3002_L4001",
    "L1008_L2006_L3002_L4002",
    "L1008_L2006_L3002_L4003",
    "L1008_L2006_L3002_L4004",
    "L1008_L2006_L3002_L4005",
    "L1008_L2006_L3002_L4006",
    "L1008_L2006_L3002_L4007",
    "L1008_L2006_L3002_L4008",
    "L1008_L2006_L3002_L4009",
    "L1008_L2006_L3002_L4010"
  ],
  L1008_L2006_L3003: [
    "L1008_L2006_L3003_L4001",
    "L1008_L2006_L3003_L4002",
    "L1008_L2006_L3003_L4003",
    "L1008_L2006_L3003_L4004",
    "L1008_L2006_L3003_L4005"
  ],
  L1002_L2001_L3001: [
    "L1002_L2001_L3001_L4001",
    "L1002_L2001_L3001_L4002",
    "L1002_L2001_L3001_L4003",
    "L1002_L2001_L3001_L4004",
    "L1002_L2001_L3001_L4005",
    "L1002_L2001_L3001_L4006",
    "L1002_L2001_L3001_L4007",
    "L1002_L2001_L3001_L4008",
    "L1002_L2001_L3001_L4009"
  ],
  L1002_L2001_L3002: ["L1002_L2001_L3002_L4001", "L1002_L2001_L3002_L4002"],
  L1002_L2002_L3001: [
    "L1002_L2002_L3001_L4001",
    "L1002_L2002_L3001_L4002",
    "L1002_L2002_L3001_L4003",
    "L1002_L2002_L3001_L4004",
    "L1002_L2002_L3001_L4005",
    "L1002_L2002_L3001_L4006",
    "L1002_L2002_L3001_L4007",
    "L1002_L2002_L3001_L4008",
    "L1002_L2002_L3001_L4009"
  ],
  L1002_L2002_L3002: [
    "L1002_L2002_L3002_L4001",
    "L1002_L2002_L3002_L4002",
    "L1002_L2002_L3002_L4003",
    "L1002_L2002_L3002_L4004",
    "L1002_L2002_L3002_L4005",
    "L1002_L2002_L3002_L4006",
    "L1002_L2002_L3002_L4007",
    "L1002_L2002_L3002_L4008"
  ],
  L1002_L2003_L3001: [
    "L1002_L2003_L3001_L4001",
    "L1002_L2003_L3001_L4002",
    "L1002_L2003_L3001_L4003",
    "L1002_L2003_L3001_L4004",
    "L1002_L2003_L3001_L4005"
  ],
  L1002_L2003_L3002: [
    "L1002_L2003_L3002_L4001",
    "L1002_L2003_L3002_L4002",
    "L1002_L2003_L3002_L4003",
    "L1002_L2003_L3002_L4004",
    "L1002_L2003_L3002_L4005"
  ],
  L1002_L2003_L3003: [
    "L1002_L2003_L3003_L4001",
    "L1002_L2003_L3003_L4002",
    "L1002_L2003_L3003_L4003",
    "L1002_L2003_L3003_L4004",
    "L1002_L2003_L3003_L4005",
    "L1002_L2003_L3003_L4006",
    "L1002_L2003_L3003_L4007"
  ],
  L1002_L2004_L3001: [
    "L1002_L2004_L3001_L4001",
    "L1002_L2004_L3001_L4002",
    "L1002_L2004_L3001_L4003"
  ],
  L1002_L2004_L3002: [
    "L1002_L2004_L3002_L4001",
    "L1002_L2004_L3002_L4002",
    "L1002_L2004_L3002_L4003",
    "L1002_L2004_L3002_L4004",
    "L1002_L2004_L3002_L4005"
  ],
  L1002_L2004_L3003: [
    "L1002_L2004_L3003_L4001",
    "L1002_L2004_L3003_L4002",
    "L1002_L2004_L3003_L4003",
    "L1002_L2004_L3003_L4004",
    "L1002_L2004_L3003_L4005",
    "L1002_L2004_L3003_L4006"
  ],
  L1016_L2001_L3001: [
    "L1016_L2001_L3001_L4001",
    "L1016_L2001_L3001_L4002",
    "L1016_L2001_L3001_L4003",
    "L1016_L2001_L3001_L4004"
  ],
  L1016_L2001_L3002: [
    "L1016_L2001_L3002_L4001",
    "L1016_L2001_L3002_L4002",
    "L1016_L2001_L3002_L4003",
    "L1016_L2001_L3002_L4004",
    "L1016_L2001_L3002_L4005",
    "L1016_L2001_L3002_L4006",
    "L1016_L2001_L3002_L4007",
    "L1016_L2001_L3002_L4008",
    "L1016_L2001_L3002_L4009",
    "L1016_L2001_L3002_L4010"
  ],
  L1016_L2001_L3003: [
    "L1016_L2001_L3003_L4001",
    "L1016_L2001_L3003_L4002",
    "L1016_L2001_L3003_L4003",
    "L1016_L2001_L3003_L4004",
    "L1016_L2001_L3003_L4005",
    "L1016_L2001_L3003_L4006",
    "L1016_L2001_L3003_L4007"
  ],
  L1016_L2001_L3004: [
    "L1016_L2001_L3004_L4001",
    "L1016_L2001_L3004_L4002",
    "L1016_L2001_L3004_L4003",
    "L1016_L2001_L3004_L4004",
    "L1016_L2001_L3004_L4005",
    "L1016_L2001_L3004_L4006"
  ],
  L1016_L2002_L3001: [
    "L1016_L2002_L3001_L4001",
    "L1016_L2002_L3001_L4002",
    "L1016_L2002_L3001_L4003",
    "L1016_L2002_L3001_L4004"
  ],
  L1016_L2002_L3002: [
    "L1016_L2002_L3002_L4001",
    "L1016_L2002_L3002_L4002",
    "L1016_L2002_L3002_L4003",
    "L1016_L2002_L3002_L4004"
  ],
  L1016_L2002_L3003: [
    "L1016_L2002_L3003_L4001",
    "L1016_L2002_L3003_L4002",
    "L1016_L2002_L3003_L4003",
    "L1016_L2002_L3003_L4004"
  ],
  L1005_L2001_L3001: [
    "L1005_L2001_L3001_L4001",
    "L1005_L2001_L3001_L4002",
    "L1005_L2001_L3001_L4003",
    "L1005_L2001_L3001_L4004",
    "L1005_L2001_L3001_L4005",
    "L1005_L2001_L3001_L4006",
    "L1005_L2001_L3001_L4007"
  ],
  L1005_L2001_L3002: [
    "L1005_L2001_L3002_L4001",
    "L1005_L2001_L3002_L4002",
    "L1005_L2001_L3002_L4003",
    "L1005_L2001_L3002_L4004"
  ],
  L1005_L2001_L3003: [
    "L1005_L2001_L3003_L4001",
    "L1005_L2001_L3003_L4002",
    "L1005_L2001_L3003_L4003",
    "L1005_L2001_L3003_L4004",
    "L1005_L2001_L3003_L4005",
    "L1005_L2001_L3003_L4006",
    "L1005_L2001_L3003_L4007",
    "L1005_L2001_L3003_L4008"
  ],
  L1005_L2001_L3004: [
    "L1005_L2001_L3004_L4001",
    "L1005_L2001_L3004_L4002",
    "L1005_L2001_L3004_L4003"
  ],
  L1007_L2001_L3001: [
    "L1007_L2001_L3001_L4001",
    "L1007_L2001_L3001_L4002",
    "L1007_L2001_L3001_L4003",
    "L1007_L2001_L3001_L4004",
    "L1007_L2001_L3001_L4005"
  ],
  L1007_L2001_L3002: [
    "L1007_L2001_L3002_L4001",
    "L1007_L2001_L3002_L4002",
    "L1007_L2001_L3002_L4003",
    "L1007_L2001_L3002_L4004",
    "L1007_L2001_L3002_L4005"
  ],
  L1007_L2001_L3003: [
    "L1007_L2001_L3003_L4001",
    "L1007_L2001_L3003_L4002",
    "L1007_L2001_L3003_L4003",
    "L1007_L2001_L3003_L4004"
  ],
  L1007_L2001_L3004: [
    "L1007_L2001_L3004_L4001",
    "L1007_L2001_L3004_L4002",
    "L1007_L2001_L3004_L4003",
    "L1007_L2001_L3004_L4004"
  ],
  L1007_L2001_L3005: [
    "L1007_L2001_L3005_L4001",
    "L1007_L2001_L3005_L4002",
    "L1007_L2001_L3005_L4003",
    "L1007_L2001_L3005_L4004",
    "L1007_L2001_L3005_L4005",
    "L1007_L2001_L3005_L4006",
    "L1007_L2001_L3005_L4007"
  ],
  L1007_L2001_L3006: [
    "L1007_L2001_L3006_L4001",
    "L1007_L2001_L3006_L4002",
    "L1007_L2001_L3006_L4003",
    "L1007_L2001_L3006_L4004",
    "L1007_L2001_L3006_L4005",
    "L1007_L2001_L3006_L4006",
    "L1007_L2001_L3006_L4007"
  ],
  L1007_L2002_L3001: [
    "L1007_L2002_L3001_L4001",
    "L1007_L2002_L3001_L4002",
    "L1007_L2002_L3001_L4003",
    "L1007_L2002_L3001_L4004"
  ],
  L1007_L2002_L3002: ["L1007_L2002_L3002_L4001"],
  L1007_L2002_L3003: ["L1007_L2002_L3003_L4001", "L1007_L2002_L3003_L4002"],
  L1007_L2002_L3004: ["L1007_L2002_L3004_L4001", "L1007_L2002_L3004_L4002"],
  L1007_L2002_L3005: [
    "L1007_L2002_L3005_L4001",
    "L1007_L2002_L3005_L4002",
    "L1007_L2002_L3005_L4003",
    "L1007_L2002_L3005_L4004"
  ],
  L1009_L2001_L3001: [
    "L1009_L2001_L3001_L4001",
    "L1009_L2001_L3001_L4002",
    "L1009_L2001_L3001_L4003",
    "L1009_L2001_L3001_L4004",
    "L1009_L2001_L3001_L4005",
    "L1009_L2001_L3001_L4006",
    "L1009_L2001_L3001_L4007",
    "L1009_L2001_L3001_L4008"
  ],
  L1009_L2001_L3002: [
    "L1009_L2001_L3002_L4001",
    "L1009_L2001_L3002_L4002",
    "L1009_L2001_L3002_L4003",
    "L1009_L2001_L3002_L4004"
  ],
  L1009_L2001_L3003: [
    "L1009_L2001_L3003_L4001",
    "L1009_L2001_L3003_L4002",
    "L1009_L2001_L3003_L4003",
    "L1009_L2001_L3003_L4004",
    "L1009_L2001_L3003_L4005"
  ],
  L1009_L2002_L3001: [
    "L1009_L2002_L3001_L4001",
    "L1009_L2002_L3001_L4002",
    "L1009_L2002_L3001_L4003",
    "L1009_L2002_L3001_L4004",
    "L1009_L2002_L3001_L4005",
    "L1009_L2002_L3001_L4006",
    "L1009_L2002_L3001_L4007",
    "L1009_L2002_L3001_L4008"
  ],
  L1015_L2001_L3001: [
    "L1015_L2001_L3001_L4001",
    "L1015_L2001_L3001_L4002",
    "L1015_L2001_L3001_L4003",
    "L1015_L2001_L3001_L4004",
    "L1015_L2001_L3001_L4005",
    "L1015_L2001_L3001_L4006",
    "L1015_L2001_L3001_L4007"
  ],
  L1015_L2001_L3002: [
    "L1015_L2001_L3002_L4001",
    "L1015_L2001_L3002_L4002",
    "L1015_L2001_L3002_L4003",
    "L1015_L2001_L3002_L4004"
  ],
  L1015_L2001_L3003: [
    "L1015_L2001_L3003_L4001",
    "L1015_L2001_L3003_L4002",
    "L1015_L2001_L3003_L4003"
  ],
  L1015_L2002_L3001: [
    "L1015_L2002_L3001_L4001",
    "L1015_L2002_L3001_L4002",
    "L1015_L2002_L3001_L4003",
    "L1015_L2002_L3001_L4004",
    "L1015_L2002_L3001_L4005"
  ],
  L1015_L2002_L3002: [
    "L1015_L2002_L3002_L4001",
    "L1015_L2002_L3002_L4002",
    "L1015_L2002_L3002_L4003",
    "L1015_L2002_L3002_L4004",
    "L1015_L2002_L3002_L4005",
    "L1015_L2002_L3002_L4006",
    "L1015_L2002_L3002_L4007",
    "L1015_L2002_L3002_L4008"
  ],
  L1015_L2002_L3003: [
    "L1015_L2002_L3003_L4001",
    "L1015_L2002_L3003_L4002",
    "L1015_L2002_L3003_L4003",
    "L1015_L2002_L3003_L4004"
  ],
  L1015_L2002_L3004: ["L1015_L2002_L3004_L4001", "L1015_L2002_L3004_L4002"],
  L1015_L2002_L3005: [
    "L1015_L2002_L3005_L4001",
    "L1015_L2002_L3005_L4002",
    "L1015_L2002_L3005_L4003"
  ],
  L1012_L2001_L3001: [
    "L1012_L2001_L3001_L4001",
    "L1012_L2001_L3001_L4002",
    "L1012_L2001_L3001_L4003",
    "L1012_L2001_L3001_L4004",
    "L1012_L2001_L3001_L4005"
  ],
  L1012_L2001_L3002: [
    "L1012_L2001_L3002_L4001",
    "L1012_L2001_L3002_L4002",
    "L1012_L2001_L3002_L4003"
  ],
  L1012_L2001_L3003: [
    "L1012_L2001_L3003_L4001",
    "L1012_L2001_L3003_L4002",
    "L1012_L2001_L3003_L4003",
    "L1012_L2001_L3003_L4004",
    "L1012_L2001_L3003_L4005"
  ],
  L1012_L2001_L3004: ["L1012_L2001_L3004_L4001"],
  L1014_L2001_L3001: ["L1014_L2001_L3001_L4001"],
  L1014_L2001_L3003: [
    "L1014_L2001_L3003_L4001",
    "L1014_L2001_L3003_L4002",
    "L1014_L2001_L3003_L4003",
    "L1014_L2001_L3003_L4004",
    "L1014_L2001_L3003_L4005",
    "L1014_L2001_L3003_L4006"
  ],
  L1014_L2001_L3004: [
    "L1014_L2001_L3004_L4001",
    "L1014_L2001_L3004_L4002",
    "L1014_L2001_L3004_L4003",
    "L1014_L2001_L3004_L4004",
    "L1014_L2001_L3004_L4005",
    "L1014_L2001_L3004_L4006",
    "L1014_L2001_L3004_L4007"
  ],
  L1014_L2001_L3005: [
    "L1014_L2001_L3005_L4001",
    "L1014_L2001_L3005_L4002",
    "L1014_L2001_L3005_L4003"
  ],
  L1003_L2001_L3001: [
    "L1003_L2001_L3001_L4001",
    "L1003_L2001_L3001_L4002",
    "L1003_L2001_L3001_L4003",
    "L1003_L2001_L3001_L4004",
    "L1003_L2001_L3001_L4005",
    "L1003_L2001_L3001_L4006"
  ],
  L1003_L2001_L3002: [
    "L1003_L2001_L3002_L4001",
    "L1003_L2001_L3002_L4002",
    "L1003_L2001_L3002_L4003",
    "L1003_L2001_L3002_L4004",
    "L1003_L2001_L3002_L4005"
  ],
  L1003_L2001_L3003: ["L1003_L2001_L3003_L4001"],
  L1014_L2002_L3001: [
    "L1014_L2002_L3001_L4001",
    "L1014_L2002_L3001_L4002",
    "L1014_L2002_L3001_L4003",
    "L1014_L2002_L3001_L4004",
    "L1014_L2002_L3001_L4005",
    "L1014_L2002_L3001_L4006",
    "L1014_L2002_L3001_L4007",
    "L1014_L2002_L3001_L4008",
    "L1014_L2002_L3001_L4009"
  ],
  L1014_L2002_L3002: [
    "L1014_L2002_L3002_L4001",
    "L1014_L2002_L3002_L4002",
    "L1014_L2002_L3002_L4003",
    "L1014_L2002_L3002_L4004",
    "L1014_L2002_L3002_L4005",
    "L1014_L2002_L3002_L4006",
    "L1014_L2002_L3002_L4007",
    "L1014_L2002_L3002_L4008"
  ],
  L1014_L2002_L3003: [
    "L1014_L2002_L3003_L4001",
    "L1014_L2002_L3003_L4002",
    "L1014_L2002_L3003_L4003",
    "L1014_L2002_L3003_L4004",
    "L1014_L2002_L3003_L4005"
  ],
  L1004_L2001_L3001: [
    "L1004_L2001_L3001_L4001",
    "L1004_L2001_L3001_L4002",
    "L1004_L2001_L3001_L4003",
    "L1004_L2001_L3001_L4004",
    "L1004_L2001_L3001_L4005",
    "L1004_L2001_L3001_L4006"
  ],
  L1004_L2001_L3002: [
    "L1004_L2001_L3002_L4001",
    "L1004_L2001_L3002_L4002",
    "L1004_L2001_L3002_L4003",
    "L1004_L2001_L3002_L4004",
    "L1004_L2001_L3002_L4005"
  ],
  L1004_L2001_L3003: [
    "L1004_L2001_L3003_L4001",
    "L1004_L2001_L3003_L4002",
    "L1004_L2001_L3003_L4003",
    "L1004_L2001_L3003_L4004",
    "L1004_L2001_L3003_L4005",
    "L1004_L2001_L3003_L4006",
    "L1004_L2001_L3003_L4007",
    "L1004_L2001_L3003_L4008"
  ],
  L1004_L2001_L3004: [
    "L1004_L2001_L3004_L4001",
    "L1004_L2001_L3004_L4002",
    "L1004_L2001_L3004_L4003",
    "L1004_L2001_L3004_L4004",
    "L1004_L2001_L3004_L4005",
    "L1004_L2001_L3004_L4006",
    "L1004_L2001_L3004_L4007",
    "L1004_L2001_L3004_L4008",
    "L1004_L2001_L3004_L4009",
    "L1004_L2001_L3004_L4010"
  ],
  L1004_L2001_L3005: [
    "L1004_L2001_L3005_L4001",
    "L1004_L2001_L3005_L4002",
    "L1004_L2001_L3005_L4003",
    "L1004_L2001_L3005_L4004",
    "L1004_L2001_L3005_L4005",
    "L1004_L2001_L3005_L4006"
  ],
  L1004_L2001_L3006: [
    "L1004_L2001_L3006_L4001",
    "L1004_L2001_L3006_L4002",
    "L1004_L2001_L3006_L4003"
  ],
  L1004_L2001_L3007: [
    "L1004_L2001_L3007_L4001",
    "L1004_L2001_L3007_L4002",
    "L1004_L2001_L3007_L4003",
    "L1004_L2001_L3007_L4004",
    "L1004_L2001_L3007_L4005",
    "L1004_L2001_L3007_L4006",
    "L1004_L2001_L3007_L4007",
    "L1004_L2001_L3007_L4008"
  ],
  L1004_L2001_L3008: [
    "L1004_L2001_L3008_L4001",
    "L1004_L2001_L3008_L4002",
    "L1004_L2001_L3008_L4003",
    "L1004_L2001_L3008_L4004",
    "L1004_L2001_L3008_L4005"
  ],
  L1004_L2002_L3001: [
    "L1004_L2002_L3001_L4001",
    "L1004_L2002_L3001_L4002",
    "L1004_L2002_L3001_L4003"
  ],
  L1004_L2002_L3002: [
    "L1004_L2002_L3002_L4001",
    "L1004_L2002_L3002_L4002",
    "L1004_L2002_L3002_L4003",
    "L1004_L2002_L3002_L4004",
    "L1004_L2002_L3002_L4005"
  ],
  L1004_L2002_L3004: ["L1004_L2002_L3004_L4001", "L1004_L2002_L3004_L4002"],
  L1004_L2002_L3005: [
    "L1004_L2002_L3005_L4001",
    "L1004_L2002_L3005_L4002",
    "L1004_L2002_L3005_L4003",
    "L1004_L2002_L3005_L4004",
    "L1004_L2002_L3005_L4005",
    "L1004_L2002_L3005_L4006"
  ],
  L1010_L2001_L3001: [
    "L1010_L2001_L3001_L4001",
    "L1010_L2001_L3001_L4002",
    "L1010_L2001_L3001_L4003",
    "L1010_L2001_L3001_L4004",
    "L1010_L2001_L3001_L4005",
    "L1010_L2001_L3001_L4006"
  ],
  L1010_L2001_L3002: [
    "L1010_L2001_L3002_L4001",
    "L1010_L2001_L3002_L4002",
    "L1010_L2001_L3002_L4003"
  ],
  L1010_L2001_L3003: [
    "L1010_L2001_L3003_L4001",
    "L1010_L2001_L3003_L4002",
    "L1010_L2001_L3003_L4003",
    "L1010_L2001_L3003_L4004",
    "L1010_L2001_L3003_L4005"
  ],
  L1010_L2002_L3001: [
    "L1010_L2002_L3001_L4001",
    "L1010_L2002_L3001_L4002",
    "L1010_L2002_L3001_L4003",
    "L1010_L2002_L3001_L4004",
    "L1010_L2002_L3001_L4005",
    "L1010_L2002_L3001_L4006"
  ],
  L1010_L2002_L3002: [
    "L1010_L2002_L3002_L4001",
    "L1010_L2002_L3002_L4002",
    "L1010_L2002_L3002_L4003"
  ],
  L1010_L2002_L3003: ["L1010_L2002_L3003_L4001", "L1010_L2002_L3003_L4002"],
  L1010_L2002_L3004: [
    "L1010_L2002_L3004_L4001",
    "L1010_L2002_L3004_L4002",
    "L1010_L2002_L3004_L4003",
    "L1010_L2002_L3004_L4004",
    "L1010_L2002_L3004_L4005",
    "L1010_L2002_L3004_L4006",
    "L1010_L2002_L3004_L4007",
    "L1010_L2002_L3004_L4008"
  ],
  L1010_L2002_L3005: [
    "L1010_L2002_L3005_L4001",
    "L1010_L2002_L3005_L4002",
    "L1010_L2002_L3005_L4003",
    "L1010_L2002_L3005_L4004",
    "L1010_L2002_L3005_L4005",
    "L1010_L2002_L3005_L4006",
    "L1010_L2002_L3005_L4007"
  ],
  L1016_L2003_L3001: [
    "L1016_L2003_L3001_L4001",
    "L1016_L2003_L3001_L4002",
    "L1016_L2003_L3001_L4003",
    "L1016_L2003_L3001_L4004",
    "L1016_L2003_L3001_L4005",
    "L1016_L2003_L3001_L4006",
    "L1016_L2003_L3001_L4007",
    "L1016_L2003_L3001_L4008",
    "L1016_L2003_L3001_L4009"
  ],
  L1016_L2003_L3002: [
    "L1016_L2003_L3002_L4001",
    "L1016_L2003_L3002_L4002",
    "L1016_L2003_L3002_L4003",
    "L1016_L2003_L3002_L4004",
    "L1016_L2003_L3002_L4005",
    "L1016_L2003_L3002_L4006"
  ],
  L1016_L2003_L3003: [
    "L1016_L2003_L3003_L4001",
    "L1016_L2003_L3003_L4002",
    "L1016_L2003_L3003_L4003",
    "L1016_L2003_L3003_L4004",
    "L1016_L2003_L3003_L4005",
    "L1016_L2003_L3003_L4006"
  ],
  L1016_L2003_L3004: ["L1016_L2003_L3004_L4001", "L1016_L2003_L3004_L4002"],
  L1013_L2001_L3001: [
    "L1013_L2001_L3001_L4001",
    "L1013_L2001_L3001_L4002",
    "L1013_L2001_L3001_L4003",
    "L1013_L2001_L3001_L4004"
  ],
  L1013_L2001_L3003: [
    "L1013_L2001_L3003_L4001",
    "L1013_L2001_L3003_L4002",
    "L1013_L2001_L3003_L4003"
  ],
  L1013_L2001_L3004: [
    "L1013_L2001_L3004_L4001",
    "L1013_L2001_L3004_L4002",
    "L1013_L2001_L3004_L4003",
    "L1013_L2001_L3004_L4004"
  ],
  L1013_L2002_L3001: ["L1013_L2002_L3001_L4001"],
  L1013_L2002_L3002: [
    "L1013_L2002_L3002_L4001",
    "L1013_L2002_L3002_L4002",
    "L1013_L2002_L3002_L4003",
    "L1013_L2002_L3002_L4004"
  ],
  L1013_L2002_L3003: [
    "L1013_L2002_L3003_L4001",
    "L1013_L2002_L3003_L4002",
    "L1013_L2002_L3003_L4003",
    "L1013_L2002_L3003_L4004",
    "L1013_L2002_L3003_L4005",
    "L1013_L2002_L3003_L4006",
    "L1013_L2002_L3003_L4007",
    "L1013_L2002_L3003_L4008"
  ],
  L1013_L2002_L3004: [
    "L1013_L2002_L3004_L4001",
    "L1013_L2002_L3004_L4002",
    "L1013_L2002_L3004_L4003",
    "L1013_L2002_L3004_L4004"
  ],
  L1013_L2002_L3005: [
    "L1013_L2002_L3005_L4001",
    "L1013_L2002_L3005_L4002",
    "L1013_L2002_L3005_L4003",
    "L1013_L2002_L3005_L4004",
    "L1013_L2002_L3005_L4005"
  ],
  L1013_L2002_L3006: [
    "L1013_L2002_L3006_L4001",
    "L1013_L2002_L3006_L4002",
    "L1013_L2002_L3006_L4003",
    "L1013_L2002_L3006_L4004",
    "L1013_L2002_L3006_L4005",
    "L1013_L2002_L3006_L4006",
    "L1013_L2002_L3006_L4007",
    "L1013_L2002_L3006_L4008"
  ],
  L1000_L2001_L3001: [
    "L1000_L2001_L3001_L4001",
    "L1000_L2001_L3001_L4002",
    "L1000_L2001_L3001_L4003",
    "L1000_L2001_L3001_L4004",
    "L1000_L2001_L3001_L4005"
  ],
  L1000_L2001_L3002: [
    "L1000_L2001_L3002_L4001",
    "L1000_L2001_L3002_L4002",
    "L1000_L2001_L3002_L4003",
    "L1000_L2001_L3002_L4004",
    "L1000_L2001_L3002_L4005",
    "L1000_L2001_L3002_L4006"
  ],
  L1000_L2001_L3003: [
    "L1000_L2001_L3003_L4001",
    "L1000_L2001_L3003_L4002",
    "L1000_L2001_L3003_L4003",
    "L1000_L2001_L3003_L4004",
    "L1000_L2001_L3003_L4005",
    "L1000_L2001_L3003_L4006"
  ],
  L1000_L2001_L3004: [
    "L1000_L2001_L3004_L4001",
    "L1000_L2001_L3004_L4002",
    "L1000_L2001_L3004_L4003",
    "L1000_L2001_L3004_L4004"
  ],
  L1000_L2001_L3005: [
    "L1000_L2001_L3005_L4001",
    "L1000_L2001_L3005_L4002",
    "L1000_L2001_L3005_L4003",
    "L1000_L2001_L3005_L4004",
    "L1000_L2001_L3005_L4005"
  ],
  L1000_L2001_L3006: [
    "L1000_L2001_L3006_L4001",
    "L1000_L2001_L3006_L4002",
    "L1000_L2001_L3006_L4003"
  ],
  L1000_L2001_L3007: [
    "L1000_L2001_L3007_L4001",
    "L1000_L2001_L3007_L4002",
    "L1000_L2001_L3007_L4003",
    "L1000_L2001_L3007_L4004"
  ]
};
module.exports = jobCategoryIdToSubcategoryMapping;
